// import element ui
import 'element-theme-default';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/index.scss';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
